<template>
  <el-container class="base-container">
    <el-header>
      <app-header></app-header>
    </el-header>
    <el-container>
      <el-aside>
        <app-nav></app-nav>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import AppHeader from '@/components/Header.vue'
import AppNav from '@/components/Nav.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AppMain',
  created () {
    // we init some basic info here
    this.initAccount().then(() => {
      this.initStaff()
      this.initWarehouses()
      this.initBrands()
      this.initAreas()
      this.initPayments()
      this.initPrintInfo()
      this.initSelfCsrOrderCnt()
    })

    setInterval(() => {
      this.initSelfCsrOrderCnt()
    }, 60000)
  },
  components: {
    AppHeader,
    AppNav
  },
  methods: {
    ...mapActions({
      initAccount: 'initAccountsAction',
      initStaff: 'initStaffAction',
      initWarehouses: 'initWarehousesAction',
      initBrands: 'initBrandsAction',
      initAreas: 'initAreaTypesAction',
      initPayments: 'initPaymentTypesAction',
      initPrintInfo: 'initPrintInfoAction',
      initSelfCsrOrderCnt: 'initCsrSelfOrderAction'
    })
  }
}
</script>

<style lang="scss">
.base-container {
  height: 100%;
}
// 我把需要覆盖element原生组件的样式的语句都写在这个地方，然后去掉了scoped。要不是的话我需要在多个组件内重复写scoped的样式。未来我再把如下语句移出单独放在另外的全局css里面
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  padding: 0 !important;
}
.el-aside {
  width: 200px !important;
  overflow: hidden !important;
  background-color: #555;
  color: #333;
  text-align: center;
  line-height: 100%;
  min-height: 100%;
}
.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 100%;
  min-height: 100%;
  font-size: 12px;
  padding: 10px !important;
}
.el-select-dropdown__item {
  font-size: 12px !important;
}
.el-date-editor {
  width: 200px !important;
}
.el-range-input {
  width: 70px !important;
}
.special-emphasize-input-text {
  .el-input {
    .el-input__inner {
      color: #2d8cf0;
      font-weight: bold;
      font-size: 14px;
    }
  }
}
.el-range-separator {
  padding: 0 2px !important;
}
.el-form-item {
  margin: 0 !important;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-tag {
  font-weight: bold;
  margin-right: 8px;
}
.el-col {
  border-radius: 4px;
  font-size: 12px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.el-form-item__label {
  font-size: 13px !important;
}
.el-table__body td,
.el-table__body th {
  padding: 0px !important;
}
.ocopHeaderLineHeightStyle .cell {
  line-height: 16px !important;
  text-align: center;
  padding-left: 2px !important;
  padding-right: 2px !important;
  word-wrap: break-word;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.csr-input-aside-return-texts {
  // margin-left: 10px;
  font-size: 13px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  .next {
    margin-left: 10px;
  }
  .strong1 {
    color: #ce8b2b;
    font-weight: bold;
  }
  .strong2 {
    color: #cc3300;
    font-weight: bold;
    font-size: 14px;
  }
  .strong3 {
    color: #ff0000;
    font-weight: bold;
    font-size: 15px;
}
}
.item-upper-lines-static-texts {
  margin-left: 10px;
  font-size: 13px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .strong {
    color: #3f3f3f;
    font-weight: bold;
    margin-right: 35px;
  }
}
.el-dialog__header {
  padding: 0px !important;
  height: 48px;
  width: 100%;
  background-color: #ccc;
}
.el-dialog__body {
  padding: 16px 12px 12px !important;
}
.list-table-empty-text {
  display: inline-block;
  font-size: 48px;
  font-weight: bold;
  margin: 250px 0;
  color: rgba(225, 225, 225, 0.55);
}
.el-table__empty-text {
  width: 100% !important;
}
.popover-table-empty-text {
  display: inline-block;
  font-size: 24px;
  font-weight: bold;
  margin: 30px 0;
  color: rgba(225, 225, 225, 0.55);
}
.table-column-list-type-color-bold {
  color: #1c6fc7 !important;
  font-weight: bold;
}
.table-column-list-isPaid-gray {
  color: rgb(128, 128, 128) !important;
  font-size: 10px;
}
.table-column-cost-type-color {
  color: #979797 !important;
}
.table-column-stock-type-color {
  font-weight: normal !important;
  color: #303030 !important;
}
.table-column-sale-type-color {
  color: #cc3300 !important;
}
.table-column-class-type-color {
  color: #920292 !important;
}
.table-column-class-itemName {
  font-weight: bold;
}
.table-column-class-itemCode {
  font-size: 10px;
}
.table-column-class-isOriginCode {
  color: #186106 !important;
  font-size: 9px;
}
.table-column-class-type-color-new {
  color: #920292 !important;
  font-weight: bold;
}
.table-column-ocop-type-color {
  color: #3289e0 !important;
  font-weight: bold;
}
.table-column-sheet-number-style {
  color: #707070 !important;
  font-weight: bold;
  font-size: 13px;
}
.table-cell-status-style-approved {
  color: #56a0f0;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-Draft {
  color: #6ba76b;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-Voided {
  color: #d45d5d;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-printed {
  color: #999999;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-unprinted {
  color: #d45d5d;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-xerosent {
  color: #999999;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-status-style-xerounsent {
  color: #d45d5d;
  font-size: 11px;
  font-weight: bold;
}
.table-cell-ocop-odd-column-zebra-style {
  background: #f1f1f1 !important;
  color: #2d8cf0;
  font-weight: bold;
}
.table-cell-ocop-even-column-zebra-style {
  color: #106fd8;
  font-weight: bold;
}
.table-cell-sheet-type-icon-inv {
  width: 13px;
  height: 16px;
  // margin-top: 9px;
  background-repeat: no-repeat;
  background-position: center;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAMAAAD6fQULAAADAFBMVEXe5erc4+ja4ObY3+XW3ePV3OLT2uHR2eDP197N1dzL1NzS2uD+/v7c4uj29/r29/n19/n09/jz9vjz9ffH0NjY3+Pa4ebZ4OXz9fjy9ffy9Pfx9Pbx9Pfw8/bv8vXCzNPCzNTX3uTu8fTAytLu8vW+ydHv8/Xt8fTt8PO8xs/Q2N/w8/W6xc3N1tzr7/K2wsvL1Nvs7/Pr7/Pv8vS0wMnI0dns8PPq7vLu8fOyvsjG0Nfq7vGwvMbEztbx8/bp7fHp7vGtucO/ydKruMK/ydHo7PCptsC9x9Dt8fOntL+7xs65xM23w8u1wMq0v8mxvcevvMWtusSqt8Gntb+mtL6ksrwAAHQAAAAAAAAZ8vwAAAAAAAAAAAAZ9CBM6wAAdvkAAAAACABNAwAAdvkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQoAAAdvgAAAAAAAAAAgAAAAAAAAAAAAAAAADYAAAA4LkAAAClgAAHEF0AAAAAAGS0mQAAdvkAAAAZ9JD0YAAAABkAAAAAAABJ1wA95ld0rMkZ9NjJWwAAdKwAAAAAAAAAAACEwAB0rMkAAGAAAAAAAAAAAAAAAAUAgABIwBAAAAcAAIAAAAACAAAAAAAAAAAAUABIAFIQXagAAAAAAABIAAAQXagAAAAAAAAKAKEAAAAAAAAAGAAAAAAAAAAZ9GwAQAAAAAAAAAAZ9MgAAAAAAAAAAAAAAAAAAAAIAAAAoxGiArA4uHWgEF52+FAAAAwAAgABAAC9XODSAAAAAWJLR0T/pQfyxQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAMpJREFUeNodymk7xDAYheFjGYOhpq1tEol6VRNb6JRMKTIy9n39/39Fxvl2X+cBJianplsz7dm5+c4CFqOlqBsnSZour6xiLVrvsR7fEHIzy7DVDeJCSEliG62YMTFGnosddGLOuSwoV7rYxV7C98eHCjrAYRoqSUprI49wHERKqbLsVyc4ZTkRWWvMoD7DOSPS/2jqC1xekdUmzA31NTLhrTd+4J23I9yIkDWNc+7W3OG+qKqqrh9s2TePeHp+eX17//gcfX3//P4BwpEgfSY2noIAAAAASUVORK5CYII=);
}
.table-cell-sheet-type-icon-cn {
  width: 15px;
  height: 13px;
  // margin-top: 9px;
  background-repeat: no-repeat;
  background-position: center center;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAMAAABBwMRzAAADAFBMVEX0xnD0xWvzw2fzw2PywV/ywVzyv1fyv1TxvU/xvEvwu0fwukPwuUD0yWv//Pb0xWz++uP++d/++Nz++Nj99tX99dD99c3888n888b98sL88b7wtzr5+fnzxV3zxGj++uD+9s799Mj988P98r/98bn98LT976/87an87KT865/vtTPzw2X++N3+9cr99MT987/98br87ar87KX76Zr86ZX755DvtC3zwmH9+Nr99MX+88DItImSd1n87qvHsHr76Zb86JH75ovusinywV7+99f98sD98rv877D97qz87Kb86pz755H75oz65YfvsibywVv+9tP98rz98Lb87af87KLHr3X75o375oj75ILusSPxv1f98bf877L97aj866L86p386JP75Yj65IP6437usCDxvlP98LP97q7HsoD86pn754775IT743764nrtrxvxvVD99Mr87q776Zn86JT75or65IT643/74nr64HTtrhjxvEz988f86pr754/75YX644D743v64Xb633DtrRXxvEn88sP97ab765/86pv76JX75Yb64nv533D632zsrBHxu0bwuULwuD7wtzbvtTLvtC7vsyrusSXusCHusB7urxrtrBLsqw0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgAAB2+FAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAADsXhAAAABIAAAA3z8AAAAAZACZAAB2+bQAAAD0oABwABkAGfQAAAAAAADnAADmV0msyT306HRbABl0rMkAAAAAAAAAAADAAACsyYQAYHQAAAAAAAAAAAAABQCAAADAEAAAB0AAgAAAAAAAAAAAAAIAAABOAAAAUADfP3gAAAAAAAAAAADfP3gAAAAAAAAAoQAAAAoAAAAYAAAAAAAAAAD0fABAABkAAAAAAAD02AAAABkAAAAAAAAAAAAAAAAAAAD4ZeVQoHYIdvgAoxGfC9AADHUCAACt4dbaAAAAAWJLR0T/pQfyxQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAANdJREFUeNpjYGBkYmZhZWPn4OTi5uHlY+AXEBQSFhEVE5eQlJKWkWWQk1dQVFJWUVVT19DU0tJi0NbR1dM3UFUzNNI0NjE1YzC3sLSytrGxtbGxs3dwdGJwdnF1s3H38LTxsvH28fVj8A8IDLLxCA6xsQkNC4+IZIgSjY6xiY2Lt0mwSUxKTmFIFUtLz7CxybTJssnOyc1jyC8oBNpUVJxVUlpWXlHJUFUNtKnGpNaxrr6hsamZoaW1rb2j09Sxq767sae3j6F/wkTpSZOnTJ02fcbM5lmzASZ8OC19/NcGAAAAAElFTkSuQmCC);
}
.table-cell-sheet-type-icon-po {
  width: 15px;
  height: 13px;
  // margin-top: 9px;
  background-repeat: no-repeat;
  background-position: center center;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAMAAABBwMRzAAADAFBMVEX///+k26Wa1pqU1JWQ05CKz4uK0IuHz4iDzYWEzoZ8yX5+zICEzoW/5b////+Z1pq/5cDV7tfM687L683G6cjD6MfD6ce/58PE6cim3Kqh2qPW7da34beT1JTV7tb2/Pno+Ozl9unk9eng9OTe9eLc9eHT79jc9eK55r6Hz4mb2J18yn+P05Dn9+va9N/g++Xe++PY+d3Q79TO8dPQ+tfP+da96sOx5LeW2Jt4yHqN0o7K6s3r++/R59WXo5qNmY+swa/Z+d3F48qRpZWWrZq/6MbP9Neq4K9zxXWLz4vJ6czv//O+0sKCioPN4NKAioG1zbmNnJCWq5qMno+MpJDP+Nai3ahwxHPG6Mjt/vHC1saCioTAz8SBjIKswK+DkIXO9NS93cKAk4TO9tWj3qlvxHLD58bs/vDE2Ml5gHqZqJyrv67S79Z7hn3P99W83MF/kYHO9tZrw2+EzYXB58Tt//G9z8CPmpHt//PY99zY+N2PoJKOoZGGlYiUr5jQ+Neh3Kdqw22FzobB6MTn+uvP59S90MDX8tzP7tPT8tfK69Cbsp6gu6TA7MfI8NCg3KZmwWmBzILF6cjt+/Hl+ero/e7f9eXb9d/b9N/W893b/+HX+97H7s7S9Nml4KtkwGio3au/6MO35Ly247u047mv4rOq4LCl3quj3amf3KWk36uK1I9lwWqP0pF9y397yn14yXx1yXlxx3Ryx3RsxnBqxG1pxGxlwmljwmhkw2lrxXAAAACgAAAAu7UAAA0AZACZAAB3GbQAAAD1yACYABkAGfUAAAAAAABeAAAnQ8Ay/z32EHZbABl2Mv8AAAAAAAAAAADAAAAy/4QAYHYAAAAAAAAAAAAABQCAAADAEAAACWwAgAAAAAAAAAAAAAIAAABOAAAAUAC7ukgAAAAAAAAAAAC7ukgAAAAAAAAArgAAAAoAAAAYAAAAAAAAAAD1pABAABkAAAAAAAD2AAAAABkAAAAAAAAAAAAAAAAAAACwGthQoADYdxgAsBrjEJAADHbZhlX8AAAAAXRSTlMAQObYZgAAAAFiS0dEDfa0YfUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAADbSURBVHjaAdAAL/8AAQIDBAUGBwgJCQoLDA0OAA8QERITExQVFhcYGRobHAAdHh8gISIjJCUmJygpKisALBItLi8wMTIzNDU2Nzg5ADo7PD0+P0BBQkNERUZHSABJSktMTU5PUFFSU1RVVlcABVhZWltcXV5fYGFiY2RlAAhmZ2hpamtsbW5vcHFWcgBzdHV2d3h5ent8fX5/gIEAgoOEhYaHiImKi4yNjo+QAJGSk5SVlpeYmZqbnJ2enwAJoKGio6SlpaanqKmqq6wArQiur7CxsrO0tba3uLm64AZFN+jmgCsAAAAASUVORK5CYII=);
}
.el-autocomplete-suggestion li {
  line-height: 22px !important;
  font-size: 13px !important;
  margin-left: 8px !important;
}
.el-autocomplete-suggestion {
  // width: 140px!important;
  height: 200px !important;
  overflow: hidden;
}
// .el-checkbox__label, .el-radio__label {
//   font-size: 12px!important;
//   display: flex;
//   align-items: center;
// }
.el-radio {
  display: flex !important;
  align-items: center !important;
}
.el-collapse-item__header {
  font-weight: bold !important;
  color: #40a0ffa1 !important;
  margin: 0 0 0 12px;
  height: 32px !important;
  line-height: 32px !important;
}
.el-table--small td,
.el-table--small th {
  padding: 0 !important;
}
</style>
